export default __webpack_public_path__ + "img/618e83fae2b83f9e54a7a2976aa94fb2.svg";